import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
import { FORMAT_TYPES, ORDER_TYPE_V, GOODS_ACTIVITY_TYPE_V, GOODS_TYPE_V } from '@src/constants';
import { userStore } from '@store/userStore'
import { deepClone, enumToView } from '@src/utils';
import moment from 'moment'
import { lotteryStore } from '@views/ordering/lottery/actor/store'
import MultiActivity from '@utils/multiActivity'

interface PayInfo {
    prepayId: string
    rescode: string // "000" 成功
    resinfo: string
}

interface UpgradeServiceItem {
    serviceGoodsId: string
    userGoodsId: string
}

class OrderStore extends StoreExt {
    @observable orderId: string = ''
    @observable payWay: string = ''
    @observable itemData: any //
    @observable payInfo: PayInfo = {} as any
    @observable upgradeServiceItem: UpgradeServiceItem // 升级服务 参数
    @observable orderStatusObj: any = '' // 订单数据
    @observable orderStatus: boolean = false // 用来控制订单交互
    @observable payStatus: boolean = false // 控制支付交互
    @observable checkOrderTest: any
    @observable checkOrderTest2: any
    @observable avaliableCouponInfo: any[] = [] // 可领优惠券信息
    @observable avaliableCouponList: any // 订购可领优惠券列表
    @observable isReceive: boolean = false
    @observable packageDetail: any = {} // 套餐详情
    @observable refuelPackageDetail: any = {} // 加油包详情
    @observable mutexActivityIdArr: string[] = []
    @observable salePrice: number
    @observable showOldPrice: boolean = true
    @observable availableCouponList: any[] = []   // 可领取优惠券列表
    @observable integralInfo: any = {} // 积分可抵扣金额信息
    @action
    setSalePrice = value => {
        runInAction(() => {
            this.salePrice = value
        })
    }
    @action
    setShowOldPrice = flag => {
        runInAction(() => {
            this.showOldPrice = flag
        })
    }
    /**
     * 套餐详情页查询可领取优惠券
     * @param {string} goodsReleaseId
     * @returns {Promise<void>}
     */
    @action
    getCouponList = async (goodsReleaseId: string) => {
        try {
            const res = await this.api.queryCouponList({ goodsReleaseId, iccid: userStore.currentDeviceInfo.simId })
            runInAction(() => {
                this.availableCouponList = res
            })
        } catch (e) {
        }
    }
    // 选择要参加的活动
    @action
    changeMutexActivity = (activityId, index, subType) => {
        const multiActivity = new MultiActivity(this.packageDetail)
        const mutexActivityList = multiActivity.formatActivityByMutexConfig() || [] // 互斥活动列表
        const activityOutMutex = multiActivity.getActivityListOutMutex() || [] // 不在互斥规则中的活动
        const allActivity = [...activityOutMutex, ...mutexActivityList]
        const arr = deepClone(this.mutexActivityIdArr)
        arr[index] = activityId
        this.mutexActivityIdArr = arr
        const hasBigSaleDto = allActivity[index].find(item => item.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
        if (subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE) {
            const dto = deepClone(this.packageDetail.activityPlan).find(item => item.activityId === activityId)
            this.setSalePrice(Number(dto.salePrice))
            this.setShowOldPrice(true)
        }
        if (subType === GOODS_ACTIVITY_TYPE_V.ORDER_FREE && !!hasBigSaleDto) {
            // 如果选择赠品且存在赠品和限时打折活动互斥，则使用原价购买
            this.setSalePrice(Number(multiActivity.getOldPrice()))
            this.setShowOldPrice(false)
        }
        if (subType === '-1' && !!hasBigSaleDto) {
            // 如果选择使用优惠券且存在优惠券和限时打折活动互斥，则使用原价购买
            this.setSalePrice(Number(multiActivity.getOldPrice()))
            this.setShowOldPrice(false)
        }
    }

    @action
    getPackageDetail = async (goodsReleaseId, simId, countryCode = '', cargoType = '', activityId = '') => {
        await this.fetchData('buyPlanQuery', goodsReleaseId, simId, countryCode, cargoType, activityId)
    }
    // 加油包详情
    @action
    getRefuelPackageDetail = async (goodsReleaseId, simId, countryCode = '', cargoType = '', activityId = '') => {
        await this.fetchData('buyRefuelPackageQuery', goodsReleaseId, simId, countryCode, cargoType, activityId)
    }
    fetchData = async (apiName, goodsReleaseId, simId, countryCode = '', cargoType = '', activityId = '') => {
        try {
            const res = await this.api[apiName]({
                goodsReleaseId: goodsReleaseId,
                simId: simId,
                cargoType: cargoType,
                areaCode: countryCode,
                activityId
            })
            const mutexActivityId = []
            if (res.length > 0) {
                res[0].infoLists = !!res[0].productInfo ? res[0].productInfo.split('\n') : []
                if (res[0].activity) {
                    const multiActivity = new MultiActivity(res[0])
                    const mutexActivityList = multiActivity.formatActivityByMutexConfig() // 互斥活动列表
                    const activityOutMutex = multiActivity.getActivityListOutMutex() // 不在互斥规则中的活动
                    if (activityOutMutex.length > 0) {
                        activityOutMutex.forEach(item => {
                            mutexActivityId.push(item.activityId)
                        })
                    }
                    if (mutexActivityList.length > 0) {
                        mutexActivityList.forEach(item => {
                            mutexActivityId.push(item[0] === '-1' ? '-1' : item[0].activityId)
                        })
                    }
                    const hasBigSale = mutexActivityList.find(item => item[0] !== '-1' && item[0].subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
                    const hasBigSaleOutMutex = activityOutMutex.find(item => item !== '-1' && item.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
                    if (!!hasBigSale || !!hasBigSaleOutMutex) {
                        this.setSalePrice((hasBigSale && Number(hasBigSale[0].salePrice)) || Number(hasBigSaleOutMutex.salePrice))
                        this.setShowOldPrice(true)
                    } else {
                        this.setSalePrice(Number(multiActivity.getOldPrice()))
                        this.setShowOldPrice(false)
                    }
                }
            }
            runInAction(() => {
                this.packageDetail = res[0] || {}
                this.mutexActivityIdArr = mutexActivityId
            })
        } catch (e) {
            console.error(e)
        }
    }

    /**
     * 查询套餐详情
     * @param {string} goodsReleaseId
     * @param {string} elementId
     * @returns {Promise<void>}
     */
    @action
    queryUnityPlanDetail = async (goodsReleaseId: string, elementId: string) => {
        try {
            const res = await this.api.queryUnityPlanDetail({ goodsReleaseId, elementId, page: '1' });
            const mutexActivityId = []
            res.infoLists = !!res.productInfo ? res.productInfo.split('\n') : []
            res.policyDegree = res.packageTraffic
            if (res.activity) {
                const multiActivity = new MultiActivity(res)
                const mutexActivityList = multiActivity.formatActivityByMutexConfig() // 互斥活动列表
                const activityOutMutex = multiActivity.getActivityListOutMutex() // 不在互斥规则中的活动
                if (activityOutMutex.length > 0) {
                    activityOutMutex.forEach(item => {
                        mutexActivityId.push(item.activityId)
                    })
                }
                if (mutexActivityList.length > 0) {
                    mutexActivityList.forEach(item => {
                        mutexActivityId.push(item[0] === '-1' ? '-1' : item[0].activityId)
                    })
                }
                const hasBigSale = mutexActivityList.find(item => item[0] !== '-1' && item[0].subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
                const hasBigSaleOutMutex = activityOutMutex.find(item => item !== '-1' && item.subType === GOODS_ACTIVITY_TYPE_V.BIG_SALE)
                if (!!hasBigSale || !!hasBigSaleOutMutex) {
                    this.setSalePrice((hasBigSale && Number(hasBigSale[0].salePrice)) || Number(hasBigSaleOutMutex.salePrice))
                    this.setShowOldPrice(true)
                } else {
                    this.setSalePrice(Number(multiActivity.getOldPrice()))
                    this.setShowOldPrice(false)
                }
            }

            runInAction(() => {
                this.packageDetail = res || {}
                this.mutexActivityIdArr = mutexActivityId
            })
        } catch (e) {
        }
    }
    // 设置支付方式
    @action
    setPayWay = (val) => runInAction(() => this.payWay = val)

    @action
    setItemData = (obj) => runInAction(() => this.itemData = obj)

    @action
    setUpgradeServiceItem = (obj: UpgradeServiceItem) => runInAction(() => this.upgradeServiceItem = obj)

    /**
     * 提交订购
     */
    @action
    submit = async (simId, payment, goodsType) => {
        const packageInfo = this.packageDetail
        const allowUseCoupon = deepClone(this.mutexActivityIdArr).includes('-1')
        const multiActivity = new MultiActivity(packageInfo)
        const idsSet = new Set(deepClone(this.mutexActivityIdArr))
        if (idsSet.has('-1')) {
            idsSet.delete('-1')
        }
        const query = {
            simId: simId,
            goodsReleaseId: packageInfo.goodsReleaseId,
            activityId: multiActivity.hasEffectiveActivity() ? Array.from(idsSet).join(',') : '',
            paymentType: payment
        }
        try {
            let res = null
            if (goodsType === GOODS_TYPE_V.JIAYOU) {
                res = await this.api.buySpeedPlan(query)
            } else {
                res = await this.api.gobuyPlan(query)
            }
            runInAction(() => this.orderId = res)
            this.setOrderStatus(false)
            localStorage.setItem('H5_URL_ORIGIN', JSON.stringify('ordering-packageorder'))
            this.goToPath(`/app/ordering/payorder/paying/${this.orderId}/${payment}/0/${allowUseCoupon || multiActivity.canUseCoupon()}/${goodsType}`)
        } catch {
            this.setOrderStatus(false)
        }
    }

    /**
     * 提交 升级服务
     */
    @action
    getServiceOrder = async ({ iccid, payment, userGoodsId = '', serviceGoodsId = '', flag }) => {
        const res = await this.api.upgradePlan({
            userGoodsId: this.upgradeServiceItem.userGoodsId || userGoodsId,
            serviceGoodsId: this.upgradeServiceItem.serviceGoodsId || serviceGoodsId,
            paymentType: payment,
            iccid: iccid,
            effectiveNow: flag ? '1' : '0'
        }).catch(e => this.setPayStatus(false))
        runInAction(() => this.orderId = res)
        if (res) {
            localStorage.setItem('H5_URL_ORIGIN', JSON.stringify('ordering-upgrade'))
            this.goToPath(`/app/ordering/payorder/paying/${res}/${payment}/1/true`)
        }
        this.setPayStatus(false)
    }

    @action
    paying = async (orderId, goodsName, payWay, relationId, useIntegral) => {
        const query = {
            orderId: orderId,
            goodsName: goodsName,
            paymentType: payWay,
            relationId: relationId,
            useIntegral: useIntegral
        }
        localStorage.setItem('PAYING_ORDER_INFO', JSON.stringify(query))
        localStorage.setItem('PAYING_ORDER_CONTNUE', JSON.stringify(query))
        const res = await this.api.payingPlan(query).catch(e => this.setPayStatus(false))
        runInAction(() => this.payInfo = res)
        localStorage.setItem('QQBROWSER', JSON.stringify(1))
        if (!!res) {
            if (payWay === '1') {
                const url = deepClone(userStore.payConfig) || ''
                const eUrl = encodeURIComponent(url)
                const NewWenUrl = res.resinfo.concat(`&redirect_url=${eUrl}`)
                window.location.href = NewWenUrl // 跳转支付
            }
            if (payWay === '2') {
                const data = res.resinfo
                const payFormDom = document.getElementById('pay_form')
                // 查询是否有支付表单存在，如果存在，删除之前的表单节点
                if (payFormDom) {
                    payFormDom.innerHTML = ''
                    payFormDom.innerHTML = data
                } else {
                    const div = document.createElement('div')
                    div.setAttribute('id', 'pay_form')
                    /* 此处form就是后台返回接收到的数据 */
                    div.innerHTML = data
                    document.body.appendChild(div)
                }
                document.forms[0].submit()
            }
        } else {
            sessionStorage.removeItem('couponInfo')
            // 订购触发抽奖活动
            // author - chenkai
            lotteryStore.getLotteryInfo()
            this.goToPath('/app/home')
        }
        this.setPayStatus(false)
    }

    @action
    setCurrentItemData = (param) => runInAction(() => {
        this.itemData = param
        localStorage.setItem('PAY_ORDER_ITEM', JSON.stringify(param))
    })

    @action
    fetchOrderStatus = async (ordid) => {
        const res = await this.api.queryThirdOrderStatus({ orderId: ordid }).catch(e => e)
        runInAction(() => this.orderStatusObj = res)
    }

    @action
    setOrderStatus = (v: boolean) => runInAction(() => this.orderStatus = v)

    @action
    setPayStatus = (v: boolean) => runInAction(() => this.payStatus = v)

    @action
    getCouponInfo = async activityId => {
        try {
            const result = await this.api.couponCollection({ activityId })
            result.map(res => {
                res.validStartTime = res.validStartTime ? moment(res.validStartTime).format(FORMAT_TYPES.DATE) : null
                res.validEndTime = res.validEndTime ? moment(res.validEndTime).format(FORMAT_TYPES.DATE) : null
                res.useTime = res.validType === '0' ? `${res.validStartTime} - ${res.validEndTime}` : `自领取之日起${res.validDays}天有效`
                res.platForm = res.platform.split(',')
                switch (res.platForm.length) {
                    case 1:
                        res.platFormName = `仅${enumToView('PLATFORM', res.platForm[0])}可用`
                        break;
                    case 2:
                        const arr = []
                        res.platForm.map(item => {
                            arr.push(enumToView('PLATFORM', item))
                        })
                        res.platFormName = arr.join(',') + '可用'
                        break
                    case 3:
                        res.platFormName = '全平台通用'
                        break
                }
            })

            runInAction(() => {
                this.avaliableCouponInfo = result
            })
        } catch (e) {
            console.error(e)
        }
    }
    @action
    receiveCoupon = async (activityId: string, discountId?: string, callback?: () => void) => {
        try {
            await this.api.receiveCoupons({
                activityId: activityId,
                discountId: discountId
            })
            this.$toast.info('领取成功', 1)
            if (callback) {
                callback()
            } else {
                runInAction(() => {
                    this.isReceive = true
                })
            }
        } catch (e) {
            console.error(e)
        }
    }
    @action
    setIsReceive = () => {
        this.isReceive = false
    }
    @action
    getAvailableCouponList = async (goodsReleaseId, activityId, orderSubType?, serviceGoodsId?, totalFee?) => {
        const param = orderSubType === ORDER_TYPE_V.UPGRADE ? { serviceGoodsId: serviceGoodsId } : { goodsReleaseId: goodsReleaseId }
        try {
            const res = await this.api.queryUseCoupon({
                ...param,
                totalFee: Number(totalFee) / 100,
                activityId: activityId === '-1' ? null : activityId
            })
            res && res.map(item => {
                item.validStartTime = item.validStartTime ? moment(item.validStartTime).format(FORMAT_TYPES.SECOND) : null
                item.validEndTime = item.validEndTime ? moment(item.validEndTime).format(FORMAT_TYPES.SECOND) : null
                item.platForm = item.platForm.split(',')
                switch (item.platForm.length) {
                    case 1:
                        item.platFormName = `仅${enumToView('PLATFORM', item.platForm[0])}可用`
                        break;
                    case 2:
                        const arr = []
                        item.platForm.map(i => {
                            arr.push(enumToView('PLATFORM', i))
                        })
                        item.platFormName = arr.join(',') + '可用'
                        break
                    case 3:
                        item.platFormName = '全平台通用'
                        break
                }
            })
            runInAction(() => {
                this.avaliableCouponList = res
            })
        } catch (e) {
            console.error(e)
        }
    }
    /**
     * 查询可抵扣金额和积分
     * @param {string} orderId
     * @returns {Promise<void>}
     */
    @action
    queryUsedIntegral = async (orderId: string, relationId?: string) => {
        try {
            const res = await this.api.queryUsedIntegral({ orderId, relationId })
            runInAction(() => {
                this.integralInfo = res
            })
        } catch (e) {
            console.error(e)
        }
    }
}

const orderStore = new OrderStore()
export { orderStore, OrderStore }
